import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserSettings } from '../models/settings.model';
import { LP_UI_CONFIG } from '../core/tokens';
import { StorageService } from '../services/storage.service';

/**
 * Settings API: HTTP calls only, no business logic
 */
@Injectable({ providedIn: 'root' })
export class SettingsApi {
  private readonly cfg = inject(LP_UI_CONFIG);
  private storage = inject(StorageService);
  private http = inject(HttpClient);

  // Headers for authentication
  private get headers() {
    return {
      Authorization: 'Bearer ' + this.storage.token(),
    };
  }

  /**
   * Fetches user settings from the API
   */
  getUserSettings(): Observable<UserSettings> {
    return this.http.get<UserSettings>(`${this.cfg.host}api/settings`, {
      headers: this.headers,
    });
  }

  /**
   * Updates user settings
   */
  updateUserSettings(settings: UserSettings): Observable<UserSettings> {
    return this.http.put<UserSettings>(`${this.cfg.host}api/settings`, settings, {
      headers: this.headers,
    });
  }
}
